export const QueryKeys = {
  journey: 'journey',
  display: 'display',
  joy: 'joy',
  list: 'list',
  search: 'search',
  globalList: 'globalList',
} as const;
